'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _adjudicators = require('../../../adjudicators');

var _adjudicators2 = _interopRequireDefault(_adjudicators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.routes.admin.adjudicators', ['ui.router', 'ngMaterial', 'ifeis.adjudicators']).config(function ($stateProvider) {
  $stateProvider.state('admin.adjudicators', {
    url: '/adjudicators',
    template: require('./tpl.html'),
    controller: 'AdminAdjudicatorsController',
    ncyBreadcrumb: {
      label: 'Adjudicators',
      parent: 'admin.dashboard'
    }
  });
}).controller('AdminAdjudicatorsController', function ($scope, fAdjudicatorService, $mdDialog, msgService) {
  $scope.invitations = [];

  function reportError(msg) {
    msgService.displayErrorMsg(msg);
  }

  $scope.edit = function ($event) {
    var adjudicator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    $mdDialog.show({
      event: $event,
      controller: function controller($scope, $mdDialog) {
        $scope.cancel = function () {
          $mdDialog.cancel();
        };

        $scope.adjudicator = angular.copy(adjudicator);

        $scope.answer = function (answer) {
          $mdDialog.hide(answer);
        };
      },
      template: ['<md-dialog ng-class="class">', '  <form novalidate name="form">', '  <md-content>', '    <md-subheader class="md-sticky-no-effect">What is the adjudicator\'s name?</md-subheader>', '    <md-input-container class="prompt-input-container">', '      <label>First Name</label>', '      <input type="text" ng-model="adjudicator.fname" class="dialog-close" required />', '    </md-input-container>', '    <md-input-container class="prompt-input-container">', '      <label>Last Name</label>', '      <input type="text" ng-model="adjudicator.lname" class="dialog-close" required />', '    </md-input-container>', '  </md-content>', '  <div class="md-actions" layout="row">', '    <md-button type="button" ng-click="cancel()" class="md-primary">Cancel</md-button>', '    <md-button type="submit" ng-disabled="form.$invalid" ng-click="answer( adjudicator )">Save</md-button>', '  </div>', '  </form>', '</md-dialog>'].join("\n")
    }).then(function (adj) {
      if (adjudicator.id) {
        if (adj.fname !== adjudicator.fname || adj.lname !== adjudicator.lname) {
          $scope.adjudicators.splice($scope.adjudicators.indexOf(adjudicator), 1);
          return fAdjudicatorService.update(adj);
        }
      } else {
        return fAdjudicatorService.create(adj);
      }
    }).then(function (adj) {
      $scope.adjudicators.push(adj);
    }).catch(function () {
      return reportError('Could not update adjudicator: ' + adjudicator.fname + ' ' + adjudicator.lname);
    });
  };

  $scope.remove = function (adjudicator) {
    fAdjudicatorService.remove(adjudicator.id).then(function () {
      $scope.adjudicators.splice($scope.adjudicators.indexOf(adjudicator), 1);
    }).catch(function () {
      reportError('The ' + adjudicator.name + ' is in use and cannot be deleted.');
    });
  };

  function refresh() {
    $scope.loading = true;
    fAdjudicatorService.get().then(function (adjudicators) {
      $scope.loading = false;
      $scope.adjudicators = adjudicators;
    });
  }

  refresh();
});


//////////////////
// WEBPACK FOOTER
// ./routes/admin/adjudicators/index.js
// module id = 511
// module chunks = 0